// extracted by mini-css-extract-plugin
module.exports = {"wrap":"totaljobs-terms_wrap__qdiKt"};